import React from "react";
import './AceroSerdan.css';
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { useInView } from "react-intersection-observer";

function AceroSerdan() {
    const {ref: imagen5, inView:imagen5IsVisible} = useInView(
        {
            "threshold": .75,
            "initialInView":true
        }
    );
    const {ref: txtAS, inView: txtASIsVisible} = useInView(
        {
            "threshold": .75,
            "initialInView":true
        }
    )
    const {ref: CotizarWhap, inView: cotizarWhapIsVisible} = useInView(
        {
            "threshold": .75,
            "initialInView":true
        }
    )
    return (
        <div class="WrapAceroSerdan" id="aceroserdan">
            <div class="AceroSerdanFlexWrap">
                <div class="WrapTextAceroSerdan">
                    <div class="titleAceroSerdan">
                        <TitleDisplayerComponent text="Serdán Inoxidables" id="AceroSerdanTxtTitle" />
                    </div>
                    <h4 ref={txtAS} className={`TxtContentAceroSerdan ${txtASIsVisible ? "txtASAnimated" : ""}`}>
                        <h3 id="BoldText">¿Necesitas algún producto de acero inoxidable a tu medida?</h3>
                        En Serdán Inoxidables hacemos todo tipo de productos en acero inoxidable a la medida y necesidades de cada cliente:
                        <ul>
                            <div class="liContentAceroSerdan liContentAceroSerdanResp">
                                <div class="liWrapAceroSerdan ">
                                    <li>Tinas </li>
                                    <li>Alacenas</li>
                                    </div>
                                    <div class="liWrapAceroSerdan ">
                                    <li>Bufeteras</li>
                                    <li>Estufas</li>
                                    </div>
                                    <div class="liWrapAceroSerdan ">
                                    <li>Cocinas</li>
            
                                    <li>Baños</li>
                                    </div>
                                    <div class="liWrapAceroSerdan ">
                                    <li>Pedestales</li>
                                    <li>Campanas</li>
                                    </div>
                                    <div class="liWrapAceroSerdan ">
                                    <li>Mesas</li>
                                    <li>Banquillos</li>
                                    </div>
                            </div>
            
                        </ul>
                        ... y cualquier otro articulo fabricable con acero inoxidable.
                        <br/>
                        Contáctenos y compártanos su idea, nosotros nos encargamos de hacerla realidad.</h4>
                        <div class="WrapWhapText">
                        <div ref={CotizarWhap} className={`CotizarWhap ${cotizarWhapIsVisible ? "CotizarWhapAnimated" : ""}`}>
                        <a id="botonLinkWhapp" href="https://wa.me/6681316676" target="_blank">
                        <img src="./Images/whatsapp.png" style={{
                                width:"50px", height:"50px"
                            }}/>
                                <h3 className="CotizarTxt">Cotizar</h3>
                                </a>
                            </div>
                       </div>
                </div>
                <div className="ImageWrapAceroSerdan">
                    <div className="AceroSerdanImageEmpresa">
                        <img ref={imagen5} src="./Images/Encabezado Serdán Inoxidables chido-09.png" className={`imgSizeAceroSerdan ${imagen5IsVisible ? "imgSizeAceroSerdanAnimated" : ""}`} alt="" />
                    </div>
                </div>
            </div>
        </div>

  
    );
}

export default AceroSerdan;
